







































































import Component from 'vue-class-component';
import sidebarFormComponent from '@/components/TheSidebarForm.vue';
import { Base } from '@/base';

@Component({
  name: 'TheSidebarRight',
  components: {
    sidebarFormComponent
  }
})
export default class TheSidebarRight extends Base {
}
